import angular from 'angular';
import controller from './edit-control-type-dialog.controller';
import template from './edit-control-type-dialog.html';
import nameMessagesTpl from './name.messages.html';
import validator, { name as validatorName1 } from './validators/control-type-unique-name.validator.directive';

export class dialogService {
  getOptions($event, {
    controlType,
    controlPreventiveEffectivenesses,
    controlDetectiveEffectivenesses,
    controlCorrectiveEffectivenesses,
    controlAdministrativeNatures,
    controlPhysicalNatures,
    controlTechnicalNatures,
    controlPrimaryControlTypes,
    controlCompensatingControlTypes,
    controlReviewSchedules,
  }) {
    return {
      controller,
      controllerAs: 'editControlTypeDialogVM',
      locals: {
        controlType,
        controlPreventiveEffectivenesses,
        controlDetectiveEffectivenesses,
        controlCorrectiveEffectivenesses,
        controlAdministrativeNatures,
        controlPhysicalNatures,
        controlTechnicalNatures,
        controlPrimaryControlTypes,
        controlCompensatingControlTypes,
        controlReviewSchedules,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
      bindToController: true,
    };
  }
}

export default angular.module('app.components.global.editControlTypeDialog', [
])
  .service('editControlTypeDialog', dialogService)
  .directive(validatorName1, validator)
  .run(($templateCache) => {
    $templateCache.put('controlType.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.global.editControlTypeDialog created');
